module.exports = __webpack_public_path__ + "img/hxpxx.40fcedbd.png";